import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
// import Drawer from "./components/Drawer";
import Wizard from "./pages/Wizard";
import Admin from "./pages/Admin";
import HomePage from "./pages/HomePage";
import Batch from "./pages/Batch";
import { Footer } from "./components/Footer";
import UploadGovernance from "./pages/UploadGovernance";

const AppLayout = () => {
  return (
    <>
      <div className="app">
        <Navbar />
        <div className="content">
          {/* <Drawer /> */}
          <main>
            <Routes>
              <Route index element={<HomePage />} />
              <Route path="wizard" element={<Wizard />} />
              <Route path="batch" element={<Batch />} />
              <Route path="admin" element={<Admin />} />
              <Route path="upload-governance" element={<UploadGovernance />} />
            </Routes>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AppLayout;
